import { useReturnDetails } from 'pages/exchange-and-return/hooks';
import { Accordion, FabSupport, Loading, Text } from 'components';
import { FontSize, FontWeight } from 'commons';
import * as S from './styles';
import { EntrySummary } from '../components';

export function StepCancelled() {
  const { returnDetails, validatingReturnDetails } = useReturnDetails();

  if (!returnDetails || validatingReturnDetails) {
    return <Loading />;
  }

  const { entries, cancelDescription, consignmentCode } = returnDetails;

  return (
    <>
      <Accordion title="Confirmação de cancelamento" defaultOpen>
        <S.Main>
          <Text size={FontSize.font12} className="error">
            <b>Atenção!</b> Essa devolução do item abaixo esta cancelada. Entre
            em contato com o Suporte Easy para informar o problema.
          </Text>

          {entries.map((summaryEntry, index) => (
            <EntrySummary key={index} summaryEntry={summaryEntry} />
          ))}

          <S.TextWrapper>
            <Text
              size={FontSize.font12}
              weight={FontWeight.bold}
              className="error"
            >
              Inconsistência na entrega
            </Text>
            <Text size={FontSize.font12} className="error">
              {cancelDescription}
            </Text>
          </S.TextWrapper>
        </S.Main>
      </Accordion>

      <FabSupport consignmentCode={consignmentCode} isReturn />
    </>
  );
}
